import { render, staticRenderFns } from "./PayerTypes.vue?vue&type=template&id=392de6b4&scoped=true&"
import script from "./PayerTypes.vue?vue&type=script&lang=ts&"
export * from "./PayerTypes.vue?vue&type=script&lang=ts&"
import style0 from "./PayerTypes.vue?vue&type=style&index=0&id=392de6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392de6b4",
  null
  
)

export default component.exports